import React, { useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import AgGridTable from "../../components/table/AgGridTable";
import { ColDef, GridOptions, ICellRendererParams } from "ag-grid-community";
import axiosInstance from "../../axios/axios";
import { END_POINTS } from "../../shared";
import paloalto_dark from "../../assets/paloalto-white.svg";
// import cisco_dark from " ../../assets/cisco-white.svg";
import cisco_dark from "../../assets/cisco-white.svg";

import arista_dark from "../../assets/arista-white.svg";
import juniperLogo from "../../assets/juniper.svg";
import juniper_dark from "../../assets/juniper-white.svg";
import cisco_assets from "../../assets/cisco-assets.svg";
import arista_assets from "../../assets/arista-assets.svg";
import paloalto_assets from "../../assets/paloalto-assets.svg";
import cveBug from "../../assets/cve-bug.svg";
import green_shield from "../../assets/green-shield.svg";
import red_shield from "../../assets/red-shield.svg";
import orange_shield from "../../assets/orange-shield.svg";
import apple_img from "../../assets/apple.svg";
import apple_dark from "../../assets/apple_dark.svg";

const UnAssignedAssets = () => {
  const [assetsData, setAssetsData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const columnDefs: ColDef[] = [
    {
      field: "device_name",
      headerName: "Asset Name",
      filter: false,
      sortable: false,
      minWidth: 150,
    },

    {
      field: "vendor",
      headerName: "Vendor",
      filter: true,
      minWidth: 120,
      cellRenderer: (params: ICellRendererParams) =>
        params.data.vendor.toLowerCase() === "cisco" ? (
          <img
            src={isDarkMode ? cisco_dark : cisco_assets}
            alt="Cisco"
            style={{ width: "60px", height: "20px" }}
          />
        ) : params.data.vendor.toLowerCase() === "juniper" ? (
          <img
            src={isDarkMode ? juniper_dark : juniperLogo}
            alt="Juniper"
            style={{ width: "60px", height: "20px" }}
          />
        ) : params.data.vendor === "paloalto" || params.data.vendor === "Palo Alto" || params.data.vendor === "palo alto" ? (
          <img
            src={isDarkMode ? paloalto_dark : paloalto_assets}
            alt="Palo Alto"
            style={{ width: "60px", height: "20px" }}
          />
        ) : params.data.vendor.toLowerCase() === "arista" ? (
          <img
            src={isDarkMode ? arista_dark : arista_assets}
            alt="Arista"
            style={{ width: "60px", height: "20px" }}
          />
        ) : params.data.vendor.toLowerCase() === "apple" || params.data.vendor.toLowerCase() === "macos" ? (
          <img
            src={isDarkMode ? apple_dark : apple_img}
            alt="Apple"
            style={{ width: "32px", height: "32px", objectFit: "contain" }}
          />
        ) : (
          <Typography
            title={params.data.vendor}
            sx={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {params.data.vendor}
          </Typography>
        ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "model",
      headerName: "OS",
      filter: true,
      minWidth: 120,
    },

    {
      field: "device_type",
      headerName: "Type",
      filter: true,
      minWidth: 100,
    },
    {
      field: "security_score",
      headerName: "Security Score",
      filter: false,
      minWidth: 120,
      cellRenderer: (params: ICellRendererParams) => {
        return params.data?.status === 3 ? (
          <Box display="flex" alignItems="center" gap={1}>
            {params.data.security_score <= 50 && (
              <img src={red_shield} alt="Low Security Score" />
            )}
            {params.data.security_score > 50 &&
              params.data.security_score < 80 && (
                <img src={orange_shield} alt="Medium Security Score" />
              )}
            {params.data.security_score >= 80 && (
              <img src={green_shield} alt="High Security Score" />
            )}
            <Typography>{Math.round(params.data.security_score)}</Typography>
          </Box>
        ) : (
          <span>
            {/* <LoopIcon sx={{ color: "text.secondary", fontSize: 16 }} /> */}
            <></>
            <span>Scanning...</span>
          </span>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    // {
    //     field: 'misconfigurations',
    //     headerName: 'Misconfigurations ',
    //     filter: true,
    //     minWidth: 150,
    //     valueFormatter: (params) => {
    //         return params.value ? new Date(params.value).toLocaleString() : 'Never';
    //     }
    // },
    // {
    //   field: "cve_score",
    //   headerName: "CVE Score",
    //   filter: true,
    //   minWidth: 150,
    //   cellRenderer: (params: ICellRendererParams) => {
    //     return params.data?.status === 3 ? (
    //       <Box display="flex" alignItems="center" gap={1}>
    //         <img
    //           src={cveBug}
    //           alt="Cve Score"
    //           style={{ width: 20, height: 20 }}
    //         />

    //         <Typography title={params.data?.cve_score}>
    //           {Math.round(params.data?.cve_score)}
    //         </Typography>
    //       </Box>
    //     ) : (
    //       ""
    //     );
    //   },
    //   cellStyle: {
    //     display: "flex",
    //     alignItems: "center",
    //   },
    // },
    {
      field: "region_name",
      headerName: "Region",
      filter: true,
      minWidth: 100,
    },
  ];

  const gridOptions: GridOptions = {
    defaultColDef: {
      sortable: true,
      resizable: true,
    },
  };

  const fetchAssetsData = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post(END_POINTS.DEVICE_LIST);
      if (response.data) {
        const filteredData = response.data?.data?.device_list.filter(
          (region: any) => region.region_name === "Unassigned"
        );
        setAssetsData(filteredData || []);
      }
    } catch (error) {
      console.error("Error fetching assets data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAssetsData();
  }, []);

  return (
    <AgGridTable
      data={assetsData}
      columnDefs={columnDefs}
      isLoading={isLoading}
      gridOptions={gridOptions}
      showSearch={true}
      height={'calc(100vh - 78px)'}
    />
  );
};

export default UnAssignedAssets;
